import { HttpError } from '../../../src/business/httpError';
import { AxiosError } from 'axios';
import { portal } from '../../assets/plugins/axios/axios';
import { CreateEsdhExportJobRequest } from '../../models/requests/createEsdhExportJob.request';
import { ToggleReadDocumentRequest } from '../../models/requests/toggleReadDocument.request';
import { DocumentTemplatesResponse } from '../../types/documentTemplate.types';

class DocumentService {
  public exportDocumentsToEsdh = async (payload: CreateEsdhExportJobRequest) => {
    try {
      await portal.post('?method=documents.exportDocumentsToEsdh', payload);
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };

  public removeOwnSharings = async (documentIds: number[]) => {
    try {
      await portal.post('?method=documents.removeOwnSharings', { documentIds });
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };

  public getMaxDocumentsPerExport = async (): Promise<number> => {
    try {
      const { data } = await portal.get('?method=documents.getMaxDocumentsPerExport');
      return data.data;
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };

  public getDocumentCategoriesAndTemplates = async (institutionCode: string): Promise<DocumentTemplatesResponse> => {
    try {
      const { data } = await portal.get('?method=documents.getDocumentCategoriesAndTemplates', {
        params: { institutionCode },
      });
      return data.data;
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };

  public markAsRead = async (payload: ToggleReadDocumentRequest): Promise<void> => {
    try {
      await portal.post('?method=documents.markAsRead', payload);
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };

  public markAsUnread = async (payload: ToggleReadDocumentRequest): Promise<void> => {
    try {
      await portal.post('?method=documents.markAsUnread', payload);
    } catch (error) {
      throw new HttpError(error as AxiosError);
    }
  };
}

export const documentService = new DocumentService();
